import Animate from 'choerodon-ui/lib/animate';
export default Animate;
